import { NgModule } from '@angular/core';

import { DropdownComponent } from "./dropdown.component";
import { CommonModule } from "@angular/common";
import { ClickOutsideModule } from 'libraries/ui_clickOutside/clickOutside.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        ClickOutsideModule,
        FontAwesomeModule,
    ],
    exports: [
        DropdownComponent,
    ],
    declarations: [
        DropdownComponent,
    ]
})
export class DropdownModule {
}
